import { get, findIndex, without, pick, forEach, includes, concat } from "lodash"
import { createReducer } from "reduxsauce"
import actionCreator from "helpers/actionCreator"
import { Types as CompositeTypes } from "modules/analyze-composite-security/model"

export const { Types, Creators } = actionCreator("ompnt/modules/analyzeCompositePerformance", {
  focusChartLine: ["focusedChartLine"],
  blurChartLine: [],
  addSelectedView: {
    props: ["factorId"],
    track: true,
    trackType: "composite-analyze-trends-select-view-factor-add",
  },
  removeSelectedView: {
    props: ["factorId", "options"],
    track: true,
    trackType: "composite-analyze-trends-select-view-factor-removal",
    trackPayload: props => pick(props, "factorId"),
  },
  selectFactorCategory: {
    props: ["factorId"],
    track: true,
    trackType: "composite-analyze-performance-category-selection",
  },
  toggle: {
    props: ["factorId", "currentState"],
    track: true,
    trackType: "composite-analyze-exposure-graph-legend-factor",
    trackPayload: ({ factorId, currentState }) => ({ factor: factorId, state: currentState ? "on" : "off" }),
  },
  toggleOnly: {
    props: ["factorId", "only", "items", "contentSetId"],
    track: true,
    trackType: "composite-analyze-exposure-graph-legend-factor",
    trackPayload: ({ factorId, contentSetId }) => ({ factor: factorId, contentSetId }),
  },
})

const DEFAULT_STATE = {
  focusedChartLine: null,
}

function handleFocusChartLine(state, { focusedChartLine }) {
  return { ...state, focusedChartLine }
}

function handleBlurChartLine(state) {
  return { ...state, focusedChartLine: null }
}

const resetGraphState = (state) => ({
  ...state,
  disabled: null,
  only: null,
})

const handleSetAggregationFunction = (state, { functionName }) => ({
  ...state,
  styleAggregation: functionName !== "all" ? functionName : null,
})

const handleAddSelectedView = (state, { factorId }) => ({
  ...state,
  views: [...(state.views || []), factorId],
  factorCategory: factorId,
})

const handleRemoveSelectedView = (state, { factorId, options }) => {
  let { factorCategory } = state
  if (factorCategory === factorId) {
    const optionIndex = findIndex(options, option => option.id === factorId)
    factorCategory = get(options, `${optionIndex - 1}.id`)
  }

  return {
    ...state,
    factorCategory,
    views: without(state.views, factorId),
  }
}

const handleSelectFactorCategory = (state, { factorId }) => {
  const newState = { factorCategory: factorId }
  const disabled = get(state, "disabled", [])
  if (factorId !== "total" && factorId !== "factors" && !includes(disabled, `${factorId}_total`)) {
    newState.disabled = concat(disabled, [`${factorId}_total`])
  }

  return { ...resetGraphState(state), ...newState }
}

const handleToggle = (state, { factorId, currentState }) => ({
  ...state,
  focusedChartLine: currentState ? factorId : null,
})

const handleToggleQS = (state, { factorId, currentState }) => ({
  ...state,
  only: null,
  disabled: currentState ? without(state.disabled, factorId) : [...(state.disabled || []), factorId],
})

const handleToggleOnlyQS = (state, { factorId, only, items }) => {
  const disabled = []
  let onlyDisplay = null

  if (only) {
    onlyDisplay = factorId
    forEach(items, item => {
      if (item.id !== factorId) {
        disabled.push(item.id)
      }
    })
  }

  return { ...state, disabled, only: onlyDisplay }
}

export const queryStringReducers = {
  [Types.SET_AGGREGATION_FUNCTION]: handleSetAggregationFunction,
  [Types.ADD_SELECTED_VIEW]: handleAddSelectedView,
  [Types.REMOVE_SELECTED_VIEW]: handleRemoveSelectedView,
  [Types.SELECT_FACTOR_CATEGORY]: handleSelectFactorCategory,
  [Types.TOGGLE]: handleToggleQS,
  [Types.TOGGLE_ONLY]: handleToggleOnlyQS,
  [CompositeTypes.SET_MODEL]: resetGraphState,
}

export default createReducer(DEFAULT_STATE, {
  [Types.FOCUS_CHART_LINE]: handleFocusChartLine,
  [Types.BLUR_CHART_LINE]: handleBlurChartLine,
  [Types.TOGGLE]: handleToggle,
})
